import axios from 'axios'

export default {
  namespaced: true,
  state: {
    questions: [],
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },

    SET(state, value) {
      state.questions = value
    },
    UPDATE(state, question) {
      if (question.response_to) {
        const index = state.responses.findIndex((p) => p.id === question.id)
        if (index >= 0) Object.assign(state.responses[index], question)
      } else {
        const index = state.questions.findIndex((p) => p.id === question.id)
        if (index >= 0) Object.assign(state.questions[index], question)
      }
    },
    REMOVE(state, itemId) {
      // let ItemIndex = state.questions.findIndex((p) => p.id === itemId)
      // state.questions.splice(ItemIndex, 1)
      // ItemIndex = state.all_questions.findIndex((p) => p.id === itemId)
      // if (ItemIndex)
      //   state.all_questions.splice(ItemIndex, 1)
    }
  },
  actions: {
    fetch({commit}, {type}) {
      commit('loading', true)
      return axios.get('/question', {params: {type}})
        .then((response) => {
          commit('SET', response.data.data)
        })
        .finally(() => commit('loading', false))
    },
    fetchRecent({commit}) {
      return axios.get('/dashboard/question')
    },
    getQuestion({commit, state}, {itemId}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.get(`/question/${itemId}`)
          .then((response) => {
            commit('SET_ONE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    updateQuestion({commit, state}, item) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.post(`/question/${item.id}`, {
          title: item.title,
          description: item.description,
          response_to: item.response_to,
          subject_id: item.subject_id,
          _method: 'PATCH'
        })
          .then((response) => {
            console.log(response)
            // commit('UPDATE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    like({commit, state}, {itemId, like, remove}) {
      return axios.post(`/question/${itemId}/like`, {like, delete: remove})
    },
    addQuestion({commit, state}, item) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.post('/question/', item)
          .then((response) => {
            commit('ADD', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    removeItem({commit}, {itemId}) {
      return new Promise((resolve, reject) => {
        axios.delete(`/question/${itemId}`)
          .then((response) => {
            commit('REMOVE', itemId)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    }
  },
  getters: {
    questions: state => state.questions,
    loading: state => state.loading
  }
}
